(function () {
  function initPdfRelocation() {
    setTimeout(() => {
      let attempts = 0;
      const maxAttempts = 50;

      const upsell = document.querySelector(".complete-look");
      const pdfBtn = document.querySelector("#who_pm_product_button_block");
      const buyButton = document.querySelector(
        ".button--add-to-cart, .product .product-form, .product-single__add-to-cart, .shopify-payment-button, .shopify-payment-button__button, .ProductForm__BuyButtons, .add-to-cart",
      );

      if (upsell && pdfBtn && buyButton) {
        if (!pdfBtn.dataset.moved) {
          buyButton.insertAdjacentElement("afterend", pdfBtn);

          pdfBtn.dataset.moved = "true";
        }

        observer.disconnect();
        return;
      }

      attempts++;
      if (attempts > maxAttempts) {
        observer.disconnect();
      }

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }, 0);
  }
  document.addEventListener("DOMContentLoaded", initPdfRelocation);
})();
